import React from "react";
import { Alert, Badge, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import {
  formatLongDate,
  getCurrencyCode,
  getPausedDates,
  includesLongDate,
  parseLongDate,
} from "../../../../../helpers/CommonHelper";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import { BiCheckCircle } from "react-icons/bi";
import { BsCheckCircleFill } from "react-icons/bs";

const Details = ({ item }) => {
  const getAllDays = (start, end) => {
    const s = new Date(start);
    const e = new Date(end);

    // Normalize to midnight
    s.setHours(0, 0, 0, 0);
    e.setHours(0, 0, 0, 0);

    const dates = [];

    while (s <= e) {
      const day = s.getDay(); // 0=Sun, 6=Sat

      if (day !== 0 && day !== 6) {
        dates.push(new Date(s));
      }

      s.setDate(s.getDate() + 1);
    }

    return dates;
  };

  const pausedDates =
    item?.paused?.pauseDate && item?.paused?.reactivationDate
      ? getPausedDates(item.paused.pauseDate, item.paused.reactivationDate)
      : [];

  return (
    <>
      <Row>
        <Col>
          <Card className="item mb-2">
            {/* ---------------- Header (Unchanged) ---------------- */}
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="m-0 p-0 ">
                <div className="d-flex ImageSectionSpacing">
                  <div className="position-relative ms-1 me-2">
                    <div className="ms-1 me-2">
                      <i className="fa fa-shopping-cart position-relative cartIcon"></i>
                    </div>
                  </div>

                  <div className="d-flex flex-column ms-1">
                    <span className="m-0 text-bold memberName text-red">
                      <Link
                        to={`/customers/${item?.customer?._id}`}
                        className="hoveredText"
                      >
                        {item?.customer?.firstName} {item?.customer?.lastName}
                      </Link>
                    </span>

                    <span className="text-custom-4 mt-1 small text-bold">
                      {item?.kid?.firstName} {item?.kid?.lastName} (
                      {item?.kid?.age} years)
                    </span>
                  </div>
                </div>
              </Card.Title>

              <div className="card-tools endColumn">
                <div className="text-right mt-xl-2 mt-lg-2 mt-md-2">
                  {item.depositReturned === "1" && (
                    <span
                      className={`badge fw-semibold  rounded-pill shadow-sm me-1  px-2 bg-warning`}
                    >
                      Deposit Returned
                    </span>
                  )}
                  {item.vegOrNonVeg && (
                    <span
                      className={`badge fw-semibold  rounded-pill shadow-sm me-1  px-2 ${
                        item.vegOrNonVeg.toLowerCase() === "veg"
                          ? "bg-success text-light"
                          : "bg-danger text-light"
                      }`}
                    >
                      {item.vegOrNonVeg}
                    </span>
                  )}
                  {item.status && (
                    <span
                      className={`badge fw-semibold rounded-pill shadow-sm me-1 px-2 ${
                        item.status === "Active"
                          ? "bg-info"
                          : item.status === "Paused"
                            ? "bg-warning text-dark"
                            : item.status === "Cancelled"
                              ? "bg-danger"
                              : item.status === "Expired"
                                ? "bg-dark"
                                : "bg-secondary"
                      }`}
                    >
                      {item.status}
                    </span>
                  )}

                  {item?.createdAt && (
                    <span className="badge badge-light me-1 text-dark">
                      Created Date:{" "}
                      <span className="text-secondary">
                        <ModuleDisplayDate value={item?.createdAt} />{" "}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </Card.Header>

            {/* ---------------- Body ---------------- */}
            <Card.Body className="p-1">
              {/* Subscription Info */}
              {item.cancellationReason && (
                <Alert className="alert-custom-1 d-flex mb-1  flex-wrap p-1 font-small">
                  <strong className="me-1 mt-1 text-custom-3">
                    Cancellation Reason:
                  </strong>
                  <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                    <span className="font-small text-normal text-custom-2 html">
                      {item.cancellationReason}
                    </span>
                  </div>
                </Alert>
              )}
              {item.depositReturnedMessage && (
                <Alert className="alert-warning d-flex mb-1  flex-wrap p-1 font-small">
                  <strong className="me-1 mt-1">
                    Deposit Returned Message:
                  </strong>
                  <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                    <span className="font-small text-normal text-custom-2 html">
                      {item.depositReturnedMessage}
                    </span>
                  </div>
                </Alert>
              )}

              <Row>
                <Col xl={4} lg={6} md={6} sm={12} className="mb-1">
                  <div
                    className="info-box borderCream rounded shadow-sm p-0"
                    style={{ backgroundColor: "#fffaf5ff" }}
                  >
                    <div className="info-box-content p-0">
                      {/* Header */}
                      <h6 className="info-box-number m-0 text-red mb-2 bg-custom-6 py-1 px-3 fw-bold rounded-top">
                        Subscription Details
                      </h6>

                      {/* Payment Info */}
                      <div className=" px-3 py-2">
                        <div className="d-flex justify-content-between py-1 border-bottom">
                          <span>Plan:</span>
                          <span className="text-bold text-capitalize">
                            {item?.plan?.title}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between py-1 border-bottom">
                          <span>Subscribed Meals:</span>
                          <span className="text-bold text-capitalize">
                            {item?.subscribedMeals?.length}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between py-1 border-bottom">
                          <span>Total Meals in Plan:</span>
                          <span className="text-bold text-capitalize">
                            {item.totalMealsInPlan}
                          </span>
                        </div>
                        <div className="d-flex  justify-content-between py-1 border-bottom">
                          <span>Subscription period:</span>
                          <span className=" text-capitalize">
                            {item.subscriptionStartDate}{" "}-{" "} 
                            {item.subscriptionEndDate}
                          </span>
                        </div>
                        {item?.cancellationDate && (
                          <div className="d-flex  justify-content-between py-1 border-bottom">
                            <span>cancellation Date:</span>
                            <span className=" text-capitalize">
                              {new Date(
                                item?.cancellationDate,
                              ).toLocaleDateString()}{" "}
                            </span>
                          </div>
                        )}
                        {item?.paused?.pauseDate && (
                          <div className="d-flex  justify-content-between py-1 border-bottom">
                            <span>Paused Date:</span>
                            <span className=" text-capitalize">
                              {new Date(
                                item?.paused?.pauseDate,
                              ).toLocaleDateString()}{" "}
                            </span>
                          </div>
                        )}
                        {item?.paused?.reactivationDate && (
                          <div className="d-flex  justify-content-between py-1 border-bottom">
                            <span>Reactivation Date:</span>
                            <span className=" text-capitalize">
                              {new Date(
                                item?.paused?.reactivationDate,
                              ).toLocaleDateString()}{" "}
                            </span>
                          </div>
                        )}
                        {item?.pausedOneTime === 1 && (
                          <div className="d-flex justify-content-between py-1 border-bottom">
                            <span>Paused One Time:</span>
                            <span className="text-bold text-custom-1 text-capitalize">
                              <ModuleDisplayBoolean
                                value={item?.disclaimerAccepted}
                                trueColor="info"
                              />
                            </span>
                          </div>
                        )}
                        {item?.disclaimerAccepted && (
                          <div className="d-flex justify-content-between py-1 border-bottom">
                            <span>Disclaimer Accepted:</span>
                            <span className="text-bold text-custom-1 text-capitalize">
                              <ModuleDisplayBoolean
                                value={item?.disclaimerAccepted}
                              />
                            </span>
                          </div>
                        )}
                        <div className="d-flex justify-content-between py-1 ">
                          <span>Total Amount:</span>
                          <span className="text-bold text-success text-capitalize">
                            {item.totalAmount} {getCurrencyCode()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                {/* Payment Details */}
                <Col xl={4} lg={6} md={6} sm={12} className="mb-1">
                  <a
                    className="info-box borderCream rounded shadow-sm p-0 cursor-pointer text-custom-2"
                    style={{ backgroundColor: "#fffaf5ff" }}
                    href={`/payments/${item?.payment?._id}`}
                  >
                    <div className="info-box-content p-0">
                      {/* Header */}
                      <h6 className="info-box-number m-0 text-red mb-2 bg-custom-6 py-1 px-3 fw-bold rounded-top">
                        Payment Details
                      </h6>

                      {/* Payment Info */}
                      <div className=" px-3 py-2">
                        {item?.payment?.transactionId && (
                          <div className="d-flex justify-content-between py-1 border-bottom">
                            <span>Transaction ID:</span>
                            <span className="text-bold text-capitalize">
                              {item?.payment?.transactionId}
                            </span>
                          </div>
                        )}
                        {item?.payment?.stripePaymentId && (
                          <div className="d-flex justify-content-between py-1 border-bottom">
                            <span>Stripe Payment ID:</span>
                            <span className="text-bold text-capitalize">
                              {item?.payment?.stripePaymentId}
                            </span>
                          </div>
                        )}
                        {item.appliedCouponId && (
                          <div className="d-flex justify-content-between py-1 border-bottom">
                            <span>Coupon Applied:</span>
                            <span className="fw-semibold">
                              {item.appliedCoupon?.couponCode || (
                                <BsCheckCircleFill className="text-success" />
                              )}
                            </span>
                          </div>
                        )}
                        {item.subTotalBeforeDiscount &&
                          item?.discountAmount > 0 && (
                            <div className="d-flex justify-content-between py-1 border-bottom">
                              <span>Sub Total (Before discount):</span>
                              <span className="fw-semibold">
                                {item?.subTotalBeforeDiscount}{" "}
                                {getCurrencyCode()}
                              </span>
                            </div>
                          )}
                        {item?.discountAmount > 0 && (
                          <div className="d-flex justify-content-between py-1 border-bottom">
                            <span>Discount:</span>
                            <span className="fw-semibold">
                              - {item?.discountAmount} {getCurrencyCode()}
                            </span>
                          </div>
                        )}
                        {item?.specialDiscountAmount > 0 && (
                          <div className="d-flex justify-content-between py-1 border-bottom">
                            <span>Special Discount:</span>
                            <span className="fw-semibold">
                              - {item?.specialDiscountAmount}{" "}
                              {getCurrencyCode()}
                            </span>
                          </div>
                        )}
                        <div className="d-flex justify-content-between py-1 border-bottom">
                          <span>
                            Sub Total{" "}
                            {item?.discountAmount > 0 && (
                              <span>(After discount)</span>
                            )}
                            :
                          </span>
                          <span className="fw-semibold">
                            {item?.subTotal} {getCurrencyCode()}
                          </span>
                        </div>

                        {item?.depositAmount > 0 && (
                          <>
                            <div className="border-bottom">
                              <div className="d-flex justify-content-between py-1 ">
                                <span>Deposit:</span>
                                <span className="fw-semibold">
                                  {item?.depositAmount} {getCurrencyCode()}
                                </span>
                              </div>
                              {(item.depositAmountFromPreviousSubscription ===
                                "1" ||
                                item.depositAmountFromPreviousSubscription ===
                                  1) && (
                                <Alert className="small p-1" variant="success">
                                  The deposit amount has been carried forward
                                  from the previous subscription upon renewal.
                                </Alert>
                              )}
                            </div>
                          </>
                        )}
                        <div className="d-flex justify-content-between py-1 border-bottom">
                          <span>VAT:</span>
                          <span className="fw-semibold">
                            {item?.vatAmount} {getCurrencyCode()}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-1 border-bottom">
                          <span>Total:</span>
                          <span className="fw-semibold">
                            {item?.totalAmount} {getCurrencyCode()}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-1">
                          <span>Payment Status:</span>
                          <span
                            className={`fw-semibold ${
                              item?.payment?.status === "1"
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            {item?.payment?.status === "1" ? "Paid" : "Unpaid"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </a>
                </Col>

                {/* Kid Info */}
                <Col xl={4} lg={6} md={6} sm={12} className="mb-1">
                  <div
                    className="info-box borderCream rounded shadow-sm p-0"
                    style={{ backgroundColor: "#fffaf5ff" }}
                  >
                    <div className="info-box-content p-0">
                      {/* Header */}
                      <h6 className="info-box-number m-0 text-red mb-2 bg-custom-6 py-1 px-3 fw-bold rounded-top">
                        Kid Information
                      </h6>

                      {/* Kid Info */}
                      <div className=" px-3 py-2">
                        <div className="d-flex justify-content-between py-1 border-bottom">
                          <span>Name:</span>
                          <span className="text-bold text-capitalize">
                            {item?.kid?.firstName} {item?.kid?.lastName}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-1 border-bottom">
                          <span>Age:</span>
                          <span className="fw-semibold">{item?.kid?.age}</span>
                        </div>

                        <div className="d-flex justify-content-between py-1">
                          <span>Gender:</span>
                          <span className="fw-semibold">
                            <Badge
                              bg={
                                item?.kid?.gender === "Girl"
                                  ? "pink"
                                  : "primary"
                              }
                              className=""
                            >
                              {item?.kid?.gender}
                            </Badge>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {item.address && (
                    <div
                      className="info-box borderCream rounded shadow-sm p-0"
                      style={{ backgroundColor: "#fffaf5ff" }}
                    >
                      <div className="info-box-content p-0">
                        {/* Header */}
                        <h6 className="info-box-number m-0 text-red mb-2 bg-custom-6 py-1 px-3 fw-bold rounded-top">
                          Shipping Address
                        </h6>
                        <div className=" px-3 py-2">
                          {item.address && (
                            <div className="m-6 w-full">
                              {/* <h6
                              className="fw-bold mb-2"
                              style={{ color: COLORS.secondary }}
                            >
                              Shipping Details
                            </h6> */}

                              <p className="text-md fw-bold mb-1">
                                {item.address.firstName} {item.address.lastName}
                              </p>

                              {item.address.email && (
                                <p className="text-sm mb-1 opacity-80">
                                  <ModuleDisplayEmail
                                    value={item.address.email}
                                  />
                                </p>
                              )}

                              {item.address.phone && (
                                <p className="text-sm mb-2 opacity-80">
                                  <ModuleDisplayPhone
                                    value={item.address.phone}
                                  />
                                </p>
                              )}

                              {(item.address.addressLine1 ||
                                item.address.addressLine2 ||
                                item.address.area ||
                                item.address.landmark ||
                                item.address.city ||
                                item.address.state ||
                                item.address.country) && (
                                <div>
                                  <p
                                    className="text-sm text-secondary mb-0"
                                    style={{ whiteSpace: "pre-line" }}
                                  >
                                    {[
                                      item.address.addressLine1,
                                      item.address.addressLine2,
                                      item.address.area,
                                      item.address.landmark,
                                      item.address.city,
                                      item.address.state,
                                      item.address.country,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                  </p>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        {/* Kid Info */}
                      </div>
                    </div>
                  )}
                </Col>
              </Row>

              {/* Subscribed Meals */}
              <Row className="mt-0 mx-auto">
                <h5 className="text-red fw-bold  pb-1 px-1">
                  Subscribed Meals ({item?.subscribedMeals?.length})
                </h5>

                <Col xl={12} className="px-1">
                  <div className="w-full overflow-x-auto">
                    <table style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th className="px-4 py-2 border border-gray font-sans font-normal text-center">
                            Date
                          </th>
                          {item?.subscribedMeals
                            ?.sort(
                              (a, b) =>
                                (a?.meal?.sortOrder || 0) -
                                (b?.meal?.sortOrder || 0),
                            )
                            ?.map((m) => (
                              <th
                                key={m.meal._id}
                                className="px-4 py-2 border border-gray font-sans text-center align-top"
                              >
                                <div className="text-gray-800 font-semibold">
                                  {m?.meal?.title}{" "}
                                  <span className="text-xs text-gray">
                                    ({m?.subscriptionActualAmount} AED / Meal ×{" "}
                                    {m?.chargedDays} Days)
                                  </span>
                                </div>
                                <div className="text-xs text-green">
                                  {m?.totalAmount} {getCurrencyCode()}
                                </div>
                              </th>
                            ))}
                        </tr>
                      </thead>

                      <tbody>
                        {getAllDays(
                          item.subscriptionStartDate,
                          item.subscriptionEndDate,
                        ).map((d, idx) => {
                          const dateStr = formatLongDate(d);

                          // Check if paused
                          const isPaused = includesLongDate(
                            pausedDates,
                            dateStr,
                          );

                          // Clean + correct meal matching by date (timezone safe)
                          const mealsForDay =
                            item.selectedMeals?.filter((m) => {
                              const mealDate = new Date(m.date);
                              mealDate.setHours(0, 0, 0, 0);

                              const current = new Date(d);
                              current.setHours(0, 0, 0, 0);

                              return mealDate.getTime() === current.getTime();
                            }) || [];

                          return (
                            <tr
                              key={idx}
                              className={`text-center text-18pt 
          ${d < new Date().setHours(0, 0, 0, 0) ? "bg-custom-7 opacity-50" : ""}
          ${
            d >= new Date().setHours(0, 0, 0, 0) && isPaused
              ? "bg-custom-8 text-gray-700"
              : ""
          }
        `}
                            >
                              <td className="px-1 py-1 border border-gray font-mono small">
                                <ModuleDisplayDate value={d} />
                              </td>

                              {isPaused ? (
                                <td
                                  colSpan={item.subscribedMeals.length}
                                  className="px-4 py-2 border border-gray font-italic font-mono font-bold text-dark"
                                >
                                  Paused by customer
                                </td>
                              ) : (
                                item.subscribedMeals.map((sub) => {
                                  const selected = mealsForDay.find(
                                    (m) => m.meal?._id === sub.meal?._id,
                                  );
                                  return (
                                    <td
                                      key={sub.meal._id}
                                      className="px-4 py-2 border border-gray font-mono small text-custom-3"
                                    >
                                      {selected ? selected.food?.title : "-"}
                                    </td>
                                  );
                                })
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Details;
